<template>
  <b-navbar class="nav-pdv">
    <b-container>
      <NavbarBrand />

      <b-navbar-nav>

        <NavbarConnectedLabel
          :message="labelMessage"
          v-if="labelMessage"
          class="pdv"
        />

        <div v-show="showResource">
            <div class="unauthorized-resource-pdv">
                Este recurso é exclusivo para o Clipp360, no ClippFácil não estará disponível
            </div>
        </div>
        <li v-if="!fullScreem">
          <a @click.prevent="requestFullScreen" class="nav-pdv-expand">
            <ExpandAllIcon :size="24" title="Expandir"></ExpandAllIcon>
          </a>
        </li>
        <li v-else>
          <a @click.prevent="closeFullscreen" class="nav-pdv-expand">
            <WindowMinimizeIcon :size="24" title="Minimizar"></WindowMinimizeIcon>
          </a>
        </li>
      </b-navbar-nav>
    </b-container>
  </b-navbar>
</template>

<script>
import ExpandAllIcon from 'vue-material-design-icons/ArrowExpand';
import WindowMinimizeIcon from 'vue-material-design-icons/WindowMinimize';
import NavbarBrand from '../../../../../../components/Navbar/NavbarBrand';
import NavbarConnectedLabel from '../../../../../../components/Navbar/NavbarConnectedLabel';

export default {
  name: 'adv-navbar',
  mounted() {
    this.checkShowResource();
  },
  props: {
    labelMessage: {
      type: String,
      required: false,
      default: () => null,
    },
  },
  data() {
    return {
      fullScreem: false,
      showResource: false,
    };
  },
  components: {
    NavbarConnectedLabel,
    NavbarBrand,
    ExpandAllIcon,
    WindowMinimizeIcon,
  },
  methods: {
    requestFullScreen() {
      this.fullScreem = true;
      const elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      }
    },
    closeFullscreen() {
      this.fullScreem = false;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },

    checkShowResource() {
      this.showResource = false;
      const resource360 = window.localStorage.getItem('resource360');

      if (resource360) {
        this.showResource = true;
      }
    },
  },
};
</script>
